<template>
  <div class="etx-container Container" :class="paragraphClassList" >
    <div class="etx-center Center">
      
      <!-- <LoaderSwiper /> -->
      <BlokkliProxyMode :isEditing="isEditing" fieldName="field_logos" :elements="logos" />
      <div class="swiper Swiper SwiperLogos" :class="entranceClassList" :data-swiper-id="sliderId">

        <div class="swiper-wrapper Swiper__wrapper">              
          <div v-for="logo in logos" class="swiper-slide Swiper__wrapper__slide">

            <a v-if="logo?.link" 
              class="etx-media Media" 
              :href="logo?.link?.uri?.path" 
              :title="logo?.icon?.alt?.alt"
              :target="logo?.link?.targetBlank ? '_blank' : '_self'"
            >
              <picture>
                <MediaIcon :media="logo?.icon" />
              </picture>
            </a>

            <div class="etx-media Media" v-else>
              <picture>
                <MediaIcon :media="logo?.icon" />
              </picture>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  logos: Array<any>
    sliderId: string
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'logos_slider',
  globalOptions: ['spacingTop', 'spacingBottom'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

</script>